import styled, { css } from 'styled-components';
import { Typography } from '../../../../../global/theme';
import { mobile_xl } from '../../../../../global/mediaQueryMixin';

interface Props {
  isActive?: boolean;
}

const OuterDiv = styled.div`
  position: relative;
  display: flex;
  ${mobile_xl(css`
    width: 100%;
  `)}
`;
const LeftSection = styled.div`
  min-width: 400px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 36px;
  ${mobile_xl(css`
    min-width: unset;
    width: 100%;
    padding-top: 2px;
    gap: 24px;
  `)}
`;

const TopSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;
  ${mobile_xl(css`
    gap: 24px;
  `)}
`;

const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Heading = styled.p`
  ${Typography.heading_xl_semibold}
  color: var(--text-primary);
  margin: 0;
`;

const SubHeading = styled.p`
  ${Typography.body_lg}
  color: var(--text-secondary);
  margin: 0;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const ButtonSection = styled.div`
  width: max-content;
  display: flex;
  align-items: center;
  gap: 16px;
  ${mobile_xl(css`
    gap: 20px;
  `)}
`;

const FormBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const Form = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;
  .fillColor {
    stroke: var(--text-primary);
  }
  .select {
    .angleDown-icon {
      path {
        stroke: var(--text-primary);
      }
    }
  }
  .dueDate {
    input {
      padding: 7px 12px;
      min-width: unset;
    }
  }
`;

const Label = styled.label`
  ${Typography.body_md_medium}
  color: var(--text-secondary);
  span {
    color: var(--accent-error);
  }
`;

const Input = styled.input`
  width: -webkit-fill-available;
  padding: 7px 12px;
  background: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  border-radius: 6px;
  ${Typography.body_lg}
  color: var(--text-primary);
  ::placeholder {
    color: var(--text-placeholder);
  }
  :focus {
    border: 0.5px solid var(--brand-primary);
  }
  :focus-visible {
    outline: none;
  }
`;

const InputDiv = styled.div`
  position: relative;
`;

const SelectInput = styled.input`
  min-width: -webkit-fill-available;
  padding: 7px 12px;
  color: var(--text-primary);
  border: 0.5px solid var(--border-primary);
  border-radius: 6px;
  background-color: var(--background-primary);
  ${Typography.body_lg}
  ::placeholder {
    color: var(--text-placeholder);
  }
  :focus-visible {
    border-color: var(--brand-primary);
    outline: unset;
  }
`;

const IconDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 12px;
  top: 9px;
  .angleDown-icon {
    transition: transform 0.3s ease;
  }
  .angleDown-icon.rotate {
    transform: rotate(180deg);
  }
`;

const SelectedText = styled.div`
  position: absolute;
  top: 8px;
  left: 12px;
  pointer-events: none;
  color: var(--text-primary);
  ${Typography.body_lg}
`;

const ItemDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1px;
  ::-webkit-scrollbar-thumb {
    background: var(--text-placeholder);
    border-radius: 12px;
    min-height: 28px;
  }
`;

const NotFound = styled.div`
  padding: 4px 10px;
  border-radius: 4px;
  ${Typography.body_md}
  color: var(--text-secondary);
`;

const ViewSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const ViewTab = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const ViewTabItem = styled.div<Props>`
  border-radius: 6px;
  border: 0.5px solid var(--border-primary);
  padding: 3px 12px;
  gap: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  ${({ isActive }) =>
    isActive &&
    css`
      background-color: var(--background-primary);
      p {
        color: var(--text-primary);
      }
      svg path {
        fill: var(--text-primary);
      }
    `}
`;

const ViewTabItemLabel = styled.p`
  ${Typography.body_md_medium}
  color: var(--text-secondary);
  margin: 0;
`;

const ViewTabItemIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SkipButton = styled.div`
  ${Typography.body_md_medium}
  color: var(--text-secondary);
  cursor: pointer;
  border: none;
  background-color: transparent;
  padding: 0;
  :hover {
    color: var(--text-primary);
  }
`;

export {
  OuterDiv,
  LeftSection,
  ButtonSection,
  TopSection,
  TitleSection,
  Heading,
  SubHeading,
  Content,
  FormBlock,
  Form,
  Label,
  Input,
  InputDiv,
  SelectInput,
  IconDiv,
  SelectedText,
  ItemDiv,
  ViewSection,
  ViewTab,
  ViewTabItem,
  ViewTabItemLabel,
  ViewTabItemIcon,
  SkipButton,
  NotFound
};
